import { map } from "lodash";

const defaultTieringColor = "Unknown";
const tieringColorMap: { [name: string]: string; } = {
  "Internal": "#b4bbcb",
  "Standard": "#444852",
  "Tier-One": "#dc4941",
  "Unknown": "#6488ff",
};

export function fromStyleLocals(locals: any) {
  return (...names: string[]) => map(names, (n) => `${n} ${locals[n] || ""}`.trim()).join(" ");
}

export function getTieringColor(tiering: string) {
  return tieringColorMap[tiering] || tieringColorMap[defaultTieringColor];
}
